module.exports = __webpack_public_path__ + "static/Anadarko-89288fbde353d7afa07b1d8697ab0c09.png";